import React from "react"

const SmallLoader = () => {
  return (
    <div
      role="status"
      className="spinner-container spinner-border"
    >
      <span className="visually-hidden">Loading...</span>
    </div>
  )
}

export default SmallLoader
